import React from 'react'
import Appsignal from '@appsignal/javascript'
import { plugin } from '@appsignal/plugin-window-events'
import { DarkTheme, LightTheme, StardustProvider } from '@myxplor/stardust'

import AppRouter from './AppRouter'

import { TokenProvider } from '../context/TokenContext'

import _config from '~/config'

const themes = {
  dark: DarkTheme,
  light: LightTheme
}

const XplorEnroll = () => {
  const appsignal = new Appsignal({
    key: _config.APPSIGNAL_KEY,
    revision: _config.BUILD_NUMBER
  })

  // it will intercept any unhandled errors
  appsignal.use(plugin({ onerror: true, onunhandledrejection: true }))

  return (
    <StardustProvider activeTheme="light" themes={themes}>
      <TokenProvider>
        <AppRouter />
      </TokenProvider>
    </StardustProvider>
  )
}

XplorEnroll.displayName = 'XplorEnroll'
export default XplorEnroll
